<template>
  <p>
    For inquiries relating to the scientific content of the workshop, please contact the VIZBI
    Committee.
  </p>
  <p>For inquiries about practical matters (registration, transport, hotels etc.), please contact:</p>
  <p style="margin-left: 2.5em">
    Monica Concepcion<br /><br />
    Tel: +1 617-714-7156<br /><br />
    7 Cambridge Center<br />
    Cambridge MA 02142<br />
    USA
  </p>
</template>
